/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import { getClient } from './WebdavClient';
import { genFileInfo } from '../utils/fileUtils';
import { createClient } from 'webdav';
import { getRequestToken } from '@nextcloud/auth';
import { getDavNameSpaces, getDavProperties } from '@nextcloud/files';
const statData = `<?xml version="1.0"?>
	<d:propfind ${getDavNameSpaces()}>
		<d:prop>
			<oc:tags />
			${getDavProperties()}
		</d:prop>
	</d:propfind>`;
/**
 * Retrieve the files list
 * @param path
 * @param options
 */
export default async function (path, options = {}) {
    const response = await getClient().stat(path, Object.assign({
        data: statData,
        details: true,
    }, options));
    return genFileInfo(response.data);
}
/**
 * Retrieve the files list
 * @param origin
 * @param path
 * @param options
 */
export async function rawStat(origin, path, options = {}) {
    const response = await createClient(origin, { headers: { requesttoken: getRequestToken() || '' } }).stat(path, {
        ...options,
        data: statData,
        details: true,
    });
    return response.data;
}
